export default __webpack_public_path__ + "static/media/runtime.cd76b24d.png";